/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import { withAuthRedirect } from "@/shared/ui";
import { AppShell } from "@/shared/ui";

import PageContent from "@layout/app/PageContent";

import { AppPopup } from "@/features/popups";
import { appLayoutContext } from "./LayoutContext";

const { Provider: ContextProvider } = appLayoutContext;

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  return (
    <ContextProvider initialState={{}}>
      <AppShell header={{ height: 0 }} navbar={{ width: 0, breakpoint: 'sm', collapsed: { mobile: true, desktop: true } }} padding={0}>
        <AppShell.Main>
          <PageContent>{children}</PageContent>
        </AppShell.Main>
        <AppPopup />
      </AppShell>
    </ContextProvider>
  );
};

export const PageView: ComponentWithChildren = ({ children }) => {
  return (
    <PageContent>
      {children}
    </PageContent>
  );
};

export default withAuthRedirect(AppLayout);
